import { mergeActionDefinitions } from "../../utils";

export default mergeActionDefinitions("Courses", {
  createCourse: [],
  deleteCourse: ["courseId"],
  fetchAllCourses: [],
  fetchAllScormPackages: [],
  handleCreateCourseFailure: ["error"],
  handleCreateCourseSuccess: [],
  handleDeleteCourseFailure: ["error"],
  handleDeleteCourseSuccess: ["courses"],
  handleFetchAllCoursesFailure: ["error"],
  handleFetchAllCoursesSuccess: ["courses"],
  handleFetchAllScormPackagesFailure: ["error"],
  handleFetchAllScormPackagesSuccess: ["scormPackages"],
  mount: [],
  unmount: [],
});
